import React from 'react'
;
import { Link } from 'react-router-dom';

const Features = () => {

    

    return (
        <div className="featured-area bg-common-style" style={{ backgroundImage: 'url("/images/background.jpg")' }}>
            <div className="container">
                <h2 className="title-default-textPrimary-left text-center">Short Term And Long Term Courses &amp; Diploma</h2>
            </div>
            <div className="container">
                <div className="row featured-wrapper" id="gallery-wrapper">
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                        <div className="featured-box">
                            <div className="featured-img-holder hvr-bounce-to-right">
                                <img src="/images/featured/feature1.jpg" className="img-responsive" alt="featured" />
                                <a href="/images/featured/feature1.jpg" className="zoom"><i className="fa fa-share-alt" aria-hidden="true" /></a>
                            </div>
                            <div className="featured-content-holder">
                                <h3><a href="#">View Online Video Tutorials</a></h3>
                                <p>Video Tutorials on Website and Mobile App. E-Learning Facility in Institute</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                        <div className="featured-box">
                            <div className="featured-img-holder hvr-bounce-to-right">
                                <img src="/images/featured/feature2.jpg" className="img-responsive" alt="featured" />
                                <a href="/images/featured/feature2.jpg" className="zoom"><i className="fa fa-share-alt" aria-hidden="true" /></a>
                            </div>
                            <div className="featured-content-holder">
                                <h3><a href="#">Master Diploma</a></h3>
                                <p>Software, GIS, 3D Animation &amp; Hardware Master Diploma more...</p>
                            </div>
                        </div>
                        <div className="featured-box">
                            <div className="featured-img-holder hvr-bounce-to-right">
                                <img src="/images/featured/feature3.jpg" className="img-responsive" alt="featured" />
                                <a href="/images/featured/feature3.jpg" className="zoom"><i className="fa fa-share-alt" aria-hidden="true" /></a>
                            </div>
                            <div className="featured-content-holder">
                                <h3><a href="#">Short Terms Courses</a></h3>
                                <p>MS office, Tally, Data Entry, Software Develpment, GIS &amp; more...</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                        <div className="featured-box">
                            <div className="featured-img-holder hvr-bounce-to-right">
                                <img src="/images/featured/feature4.jpg" className="img-responsive" alt="featured" />
                                <a href="/images/featured/feature4.jpg" className="zoom"><i className="fa fa-share-alt" aria-hidden="true" /></a>
                            </div>
                            <div className="featured-content-holder">
                                <h3><a href="#">Diploma</a></h3>
                                <p>D.Ed.C, Software, GIS, 3D Animation &amp; Hardware Diploma more...</p>
                            </div>
                        </div>
                        <div className="featured-box">
                            <div className="featured-img-holder hvr-bounce-to-right">
                                <img src="/images/featured_image5.jpg " className="img-responsive" alt="featured" />
                                <a href="/images/featured_image5.jpg" className="zoom"><i className="fa fa-share-alt" aria-hidden="true" /></a>
                            </div>
                            <div className="featured-content-holder">
                                <h3><a href="#">Fashion Design &amp; Parlor</a></h3>
                                <p>Fashion Designing &amp; Parlor &amp; Hair Style Courses &amp; More...</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="view-all-btn-area">
                    <Link to='https://www.youtube.com/channel/UCAEonaUaC94gUq6vXneAlSg?view_as=subscriber' className="ghost-btn-big">View video Tutorials</Link>
                    <Link to='/allcourses' className="ghost-btn-big mx-2 mt-3">View All Courses</Link>
                </div>
            </div>
        </div>
    )
}

export  {Features};